module.exports = __webpack_public_path__ + "static/media/reminders.710e4cbe.svg";